<template>
  <div class="companyunits">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Company Unit</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Company Units</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a href="#" class="btn add-btn" @click="openDialog"
                  ><i class="fa fa-plus"></i> Add Comapny Unit</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterCompanyUnit"
                  style="height: 55px !important"
                />
                <label class="focus-label">Search Company Units</label>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <v-data-table
                  :headers="headers"
                  :items="searchCompanyUnit"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.stat`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> New
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="setEditCompanyUnit(item)"
                          data-toggle="modal"
                          data-target="#edit_companyunit"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteCompanyUnit(item)"
                          data-toggle="modal"
                          data-target="#delete_companyunit"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Company Unit Modal -->

        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Company Unit</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label
                    >Company Unit Name <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    v-model.trim="$v.name.$model"
                    id="name"
                    name="name"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.name.$error }"
                  />
                  <div
                    v-if="submitted && !$v.name.required"
                    class="invalid-feedback"
                  >
                    Company Unit Name is required
                  </div>

                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <!-- /Add Company Unit Modal -->

        <!-- Edit Company Unit Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Company Unit</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label
                    >Company Unit Name <span class="text-danger">*</span></label
                  >
                  <input
                    type="text"
                    id="name"
                    name="name"
                    v-model="companyUnit.name"
                    class="form-control"
                  />
                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>

                <div class="submit-section">
                  <button
                    @click.prevent="updateDepartment"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Company Unit Modal -->

        <!-- Delete Company Unit Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Company Unit</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="deleteCompanyUnit"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a @click="closeDelete" class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Company Unit Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { required } from "vuelidate/lib/validators";
import { organizationService } from "@/services/organizationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      headers: [
        {
          text: "Company Unit Name",
          align: "start",
          value: "name"
        },
        {
          text: "Status",
          align: "start",
          value: "stat",
          sortable: false
        },
        { text: "", value: "actions", sortable: false }
      ],
      name: "",
      filterCompanyUnit: "",
      company: authenticationService.currentOfficeValue,
      status: 0,
      companies: [],
      companyUnit: {},
      companyunits: [],
      department: {},
      submitted: false,
      loading: false,
      error: "",
      dialog: false,
      dialogEdit: false,
      dialogDelete: false
    };
  },
  validations: {
    name: { required }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },

  computed: {
    searchCompanyUnit: function() {
      return this.companyunits.filter(d =>
        d.name.toLowerCase().match(this.filterCompanyUnit.toLowerCase())
      );
    }
  },

  methods: {
    clearModel() {
      this.name = "";
      this.submitted = false;
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },

    openDialog() {
      this.dialog = true;
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    setEditCompanyUnit(model) {
      this.companyUnit = model;
      this.dialogEdit = true;
    },

    setDeleteCompanyUnit(model) {
      console.log(model);
      this.companyUnit = model;
      this.dialogDelete = true;
    },
    getCompanies() {
      organizationService.getCompanies().then(
        model => {
          this.companies = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getCompanyUnits() {
      organizationService.getCompanyUnits(this.company.id).then(
        model => {
          this.companyunits = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    updateDepartment() {
      this.submitted = true;

      this.loading = true;
      //console.log('department updated 1')
      organizationService
        .updateCompanyUnit(
          this.companyUnit.id,
          this.companyUnit.name,
          this.companyUnit.Status
        )
        .then(
          id => {
            organizationService.getCompanyUnits(this.company.id).then(o => {
              this.companyunits = o;
              this.closeEdit();
            });
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
    },
    setDepartment(item) {
      this.department = item;
    },
    deleteCompanyUnit() {
      //console.log(this.department)
      const id = this.companyUnit.id;
      organizationService.removeCompanyUnit(id).then(
        id => {
          organizationService.getCompanyUnits(this.company.id).then(o => {
            this.companyunits = o;
            this.closeDelete();
          });
        },
        e => {
          this.error = "Company Unit being used in some information";
          this.closeDelete();
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      console.log("valid");
      this.loading = true;
      organizationService.addCompanyUnit(this.company.id, this.name).then(
        id => {
          organizationService.getCompanyUnits(this.company.id).then(o => {
            this.companyunits = o;
            this.dialog = false;
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },
  mounted() {
    this.getCompanyUnits();
  },
  name: "companyunits"
};
</script>



// WEBPACK FOOTER //
// src/components/miscs/companyunits.vue